import React from 'react';

/**
 * FieldLabel — label con ícono opcional para los controles NO dimensionales de la caja
 * de filtros (precio/posición/descuento/búsqueda). Replica 1:1 el markup del label que
 * `FilterDropdown` usa para los dropdowns dimensionales, para que TODOS los campos de la
 * caja tengan el mismo lenguaje visual (PT-#45 #16: ícono en todos los labels).
 *
 * El ícono se atenúa igual que en los dropdowns (`text-gray-400`). Pasar íconos de
 * lucide-react con tamaño `h-3.5 w-3.5` para concordar con `DIMENSION_ICONS`.
 */
export interface FieldLabelProps {
  icon?: React.ReactNode;
  children: React.ReactNode;
}

const FieldLabel: React.FC<FieldLabelProps> = ({ icon, children }) => (
  <label className="flex items-center gap-1.5 text-sm font-medium text-gray-700 mb-1">
    {icon && <span className="text-gray-400 flex-shrink-0">{icon}</span>}
    <span>{children}</span>
  </label>
);

export default FieldLabel;
